/**
 * Shared styling for the square icon buttons in the navbar's right-hand cluster
 * (recycle bin, lock, release notes, help/tours, account). Kept in one place so the
 * hover and focus affordances stay identical across them - they had drifted, and
 * only the lock button had a hover state.
 *
 * Apply to the element that actually takes focus (the <button>/<a>), so the hover
 * background and the focus ring share one box.
 *
 * `nav-icon-button` / `nav-icon-button-filled` style nothing on their own; they are hooks
 * for the EN-1476 Halloween navbar CSS in index.css.
 */
export const NAV_ICON_BUTTON_CLASS_BASE =
    "nav-icon-button focused flex items-center justify-center p-2 rounded-lg max-h-[36px] max-w-[36px] transition-colors";

/** The interactive ghost button: base plus its hover. */
export const NAV_ICON_BUTTON_CLASS = `${NAV_ICON_BUTTON_CLASS_BASE} cursor-pointer hover:bg-gray-200/80`;

/** Icon sizing/colour used inside a nav icon button. */
export const NAV_ICON_CLASS = "w-5 h-5 text-color-600";

/**
 * The account button keeps its filled identity (bg-max-25 + border) rather than
 * joining the ghost buttons, so it gets the matching shape/transition with a
 * hover tint that reads against the fill instead of the gray one.
 */
export const NAV_ICON_BUTTON_FILLED_CLASS =
    "nav-icon-button nav-icon-button-filled focused flex items-center justify-center p-2 rounded-lg max-h-[36px] max-w-[36px] transition-colors bg-max-25 border border-solid border-gray-200";

/**
 * Hover for the filled button, kept OUT of the class above so a disabled state can simply omit it.
 * Overriding it with a second `hover:bg-*` would leave the winner up to the order Tailwind happens
 * to emit the two utilities in (same specificity), which is not something to depend on.
 */
export const NAV_ICON_BUTTON_FILLED_HOVER_CLASS = "cursor-pointer hover:bg-max-100";
